<template>
  <div>
    <b-form-select
      :disabled="isDisabled"
      v-model="value"
      class="my-0"
      id="input-1"
    >
      <option
        v-for="item in rejectReasons" :key="item.id"
        :value="item.id"
      >
      {{item.description}}
      </option>
    </b-form-select>
  </div>
</template>

<script>

export default {
  props: ["value", "isDisabled", "rejectReasons"],
  watch: {
      value() {
          this.$emit('input', this.value);
      }
  }
};
</script>
